import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router, NavigationExtras } from "@angular/router";
import {EventService} from "../../core/services/event.service";
import { HybridToolsService } from '../../core/services/hybrid-tools.service';
import {PageService} from "../../core/services/page.service";
import {Angulartics2} from "angulartics2";
import { ProgressService } from '../../core/services/progress.service';

declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-email-templates',
  templateUrl: './email-templates.component.html',
  styleUrls: ['./email-templates.component.scss']
})
export class EmailTemplatesComponent implements OnInit, OnDestroy {
  public template: any = {};
  public templateOpen: boolean;
  private templates = [];
  public user: string;
  public pageUrl: string;
  public teamPageUrl: string;
  public amountRaised: string;
  public fundraisingGoal; string;
  private eventSubscription;
  value = 12;
  gql: any = {};

  private templateIcons = {
    ETOOLS_THANKYOU: `assets/img/emailTemplates/thank-you.svg`,
    ETOOLS_DONATION_REQUEST: `assets/img/emailTemplates/donation-request.svg`,
    ETOOLS_TEAM_INVITATION: `assets/img/emailTemplates/team-invitation.svg`,
    ETOOLS_TEAM_CAPTAIN_MSG: `assets/img/emailTemplates/team-captain-message.svg`
  }

  constructor( private activatedRoute: ActivatedRoute,
               public eventService: EventService,
               public pageService: PageService,
               private angulartics2: Angulartics2,
               private router: Router,
               private progressService: ProgressService,
               public hybridToolsService: HybridToolsService) {
    this.eventSubscription = this.eventService.onEventChange.subscribe(event => {
      this.progressService.startProgress(false);
      this.eventService.getEmailTemplates(this.getAdoptedEventId()).subscribe(res => {
        this.getReplaceData(res.AdoptedEvent[0].tieredEmailTemplates.map(x => Object.assign({}, x)));
      })
      this.templateOpen = false;
    });
  }

  ngOnInit() {
    this.user = this.eventService.selectedEvent.gql.Participant[0].individualConstituent.firstName + ' '
        + this.eventService.selectedEvent.gql.Participant[0].individualConstituent.lastName;
    this.getReplaceData(this.activatedRoute.snapshot.data['emailTemplates'].map(x => Object.assign({}, x)));
    this.pageService.getUserPage(this.eventService.selectedEvent['participantId'], false).subscribe(res => {
      this.pageUrl = res.fullUrl;
    });
  };

  ngOnDestroy() {
    this.eventSubscription.unsubscribe();
  }

  getAdoptedEventId() {
    return this.eventService.selectedEvent.gql.Participant[0].adoptedEvent.adoptedEventId;
  }

  changeRoute() {
    this.router.navigate(
        ['/emailTemplates', this.value + 1]);
    this.value += 1;
  }

  getReplaceData(data) {
    this.templates = [...data];
    if (this.eventService.selectedEvent.gql.Participant[0].team) {
      if (!this.eventService.selectedEvent.gql.Participant[0].teamRoleType ||
			this.eventService.selectedEvent.gql.Participant[0].teamRoleType.name !== 'CAPTAIN') {
        this.templates.forEach(function (item, index, object) {
          if (item.sysTemplateTypeName === 'ETOOLS_TEAM_CAPTAIN_MSG') {
            object.splice(index, 1);
          }
        });
      }
      this.pageService.getTeamPage(this.eventService.selectedEvent['participantId'],
                                   this.eventService.selectedEvent.gql.Participant[0].team.teamId, false).subscribe(res => {
        this.teamPageUrl = res.fullUrl;
      });
    } else {
      this.templates.forEach(function (item, index, object) {
        if (item.sysTemplateTypeName === 'ETOOLS_TEAM_CAPTAIN_MSG') {
          object.splice(index, 1);
        }
      });
    }

    this.amountRaised = this.eventService.getIndividualTotalRaised();
    this.fundraisingGoal = this.eventService.selectedEvent.gql.Participant[0].fundraiser.fundraisingGoal;
    this.progressService.stopProgress(false);
  }

  openTemplate(template) {
    this.template = template;
    var participantName = /{participantName}/gi;
    var fundraiserPageID = /{fundraiserPageID}/gi;
    var teamPageID = /(\[|\$\()*PLEASE INSERT TEAM PAGE URL HERE(\]|\))*/gi;
    var amountRaised = /(\[|\$\()*PLEASE INSERT AMOUNT RAISED HERE(\]|\))*/gi;
    var fundraisingGoal = /(\[|\$\()*PLEASE INSERT FUNDRAISING GOAL HERE(\]|\))*/gi;
    this.template.content = this.template.content.replace(participantName, this.user);
    this.template.content = this.template.content.replace(fundraiserPageID, '<a href="' + this.pageUrl + '" class="text-primary">' + this.pageUrl + '</a>');
    this.template.content = this.template.content.replace(teamPageID, '<a href="' + this.teamPageUrl + '" class="text-primary">' + this.teamPageUrl + '</a>');
    this.template.content = this.template.content.replace(amountRaised, '$' + this.amountRaised);
    this.template.content = this.template.content.replace(fundraisingGoal, '$' + this.fundraisingGoal);
    this.templateOpen = true;
    this.angulartics2.eventTrack.next({
      action: 'Select Template',
      properties: {category: 'Email Center'}
    });
    window.scroll(0, 0);

    setTimeout(() => {
      const that = this;
      $('.templates-text a').each(function (item) {
        $(this).attr('data-link', $(this).attr('href')).removeAttr('href');
        $(this).addClass('link');
        $(this).bind('click', function () {
          let link = $(this).attr('data-link');
          if (!link.startsWith('http')) {
            link = 'http://' + link;
          }
          that.hybridToolsService.openExternalLink(link);
        });
      });
    }, 100);
  }

}
